import React, { useState } from "react";
import {
    useChangePassword,
    useCurrentUser,
    useMe,
    useUpdateMe,
} from "../actions/auth";
import "./style/input.css";
import log from "cslog";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { UserOutlined } from "@ant-design/icons";
import { Alert, Button, Col, Form, Grid, Input, Row, Space } from "antd";

import Loading from "../common/Loading";

const { useBreakpoint } = Grid;

function UpdateProfile({ enable_footer = true }) {
    const [form] = Form.useForm();
    const { data: dataCU, isSuccess: successCU } = useCurrentUser();
    const updateMutation = useUpdateMe();
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    log.d(dataCU, "Data CurretnUser");

    if (!successCU) {
        return <Loading />;
    }

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="Update Profile"
                    icon={<UserOutlined />}
                />
            }
            footer={enable_footer}
        >
            <Form
                form={form}
                layout="vertical"
                requiredMark="optional"
                name="normal_login"
                style={{
                    maxWidth: isMobile ? "100%" : "500px",
                    padding: isMobile ? "12px 16px" : "15px",
                }}
                initialValues={dataCU}
                onFinish={(values) => {
                    log.d(values, "Values");
                    updateMutation.mutate(values);
                }}
            >
                <Row gutter={[10, isMobile ? 0 : 10]}>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="first_name"
                            label="First Name"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter first name",
                                },
                            ]}
                        >
                            <Input size={isMobile ? "large" : "middle"} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            name="last_name"
                            label="Last Name"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter last name",
                                },
                            ]}
                        >
                            <Input size={isMobile ? "large" : "middle"} />
                        </Form.Item>
                    </Col>
                </Row>
                {/* <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                        {
                            required: true,
                            message: "Please enter email",
                        },
                    ]}
                    type="email"
                >
                    <Input disabled={true} size={isMobile ? "large" : "middle"} />
                </Form.Item> */}
                <Form.Item
                    name="mobile"
                    label="Mobile"
                    rules={[
                        {
                            required: true,
                            message: "Please enter mobile",
                        },
                    ]}
                >
                    <Input
                        disabled={true}
                        size={isMobile ? "large" : "middle"}
                    />
                </Form.Item>

                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        block={isMobile}
                        size={isMobile ? "large" : "middle"}
                        loading={updateMutation.isLoading}
                    >
                        Update
                    </Button>
                </Form.Item>
                {updateMutation.isSuccess && (
                    <Alert
                        message="Profile updated successfully"
                        type="success"
                    />
                )}
            </Form>
        </QurealSection>
    );
}

export default UpdateProfile;
